import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import TablePage from "../../../components/Pages/TablePage/TablePage";
import {useSocket} from "../../../hooks/useSocket";
import StatusCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/StautsCell/StatusCell";
import {useAPI} from "../../../hooks/useAPI";
import {General_API} from "../General_API";
import {formatDate} from "../../../utils/utils";
import {AuthContext} from "../../../context/AuthContext";

type NotificationsTypes = {
    className?: string;
};

function Notifications(props: NotificationsTypes) {
    const {APIRequest} = useAPI();
    const {userId} = useContext(AuthContext);

    //Работа с сокетами

    const {sendMessage} = useSocket(
        process.env.REACT_APP_SOCKET_HOST,
        onMessage,
        onConnect
    );

    function onConnect(socket) {
        socket.emit("join" , userId);
    }

    function onMessage(socket) {
        socket.on("newRequestAdded", (newRequest) => {
            setData((prev) => [...prev, newRequest]);
        });
        socket.on("changeStatus", () => {
            getData();
        });
    }

    //Модальное окно

    //Страница
    const [filterOptions, setFilterOptions] = useState("");
    const [limit, setLimit] = useState(20);
    const [data, setData] = useState([]);

    const [pagination, setPagination] = useState({
        limit: 20,
        resultsCount: 0,
        offset: 1,
        allPages: 2,
    });
    const toBegin = () => {
        let a = document.createElement('a')
        a.href = '#first-row'
        a.click()

        window.history.back()

    }

    function offsetHandler(offset) {
        setPagination({...pagination, offset: offset});
    }

    function limitHandler(limit) {
        setPagination({...pagination, limit});
    }

    const filterHandler = (e) => {
        setFilterOptions(e);
        offsetHandler(1);
    };

    //Получение данных

    const getData = async () => {
        await APIRequest(
            General_API.notifications.getNotificationById(userId, pagination.limit, pagination.offset, filterOptions)
        ).then((res) => {
            if (res.status === 200) {
                setData(res?.body?.data);
                if (res?.body?.pagination) {
                    setPagination(value => ({...value, resultsCount: res?.body?.pagination?.resultsCount}))
                }
            }
        });
    };

    useEffect(() => {
        getData();
        toBegin()
    }, [pagination.limit, pagination.offset,filterOptions]);

    //Осталаьное
    const statusColorSwitcher = (
        status: "В ожидании" | "В работе" | "Одобрено" | "Отклонено"
    ) => {
        if (status === "В ожидании") return "blue";
        if (status === "Отклонено") return "red";
        if (status === "В работе") return "orange";
        if (status === "Одобрено") return "green";
        if (status) return "green";
    };

    // @ts-ignore
    return (
        <>
            <TablePage
                pageName={"TablePage"}
                loading={false}
                tableFirstRow={[
                    {title: " ", style: {display: "none"}},
                    {title: "#"},
                    {title: "Тип запроса", style: {minWidth: "300px"}},
                    {title: "Дата"},
                    {title: "Статус"},
                ]}
                tableHaveToShow={[
                    {
                        type: "wrapperCell",
                        typeData: {cell: (props) => " "},
                    },
                    {
                        type: "wrapperCell",
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.ticket_id}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        typeData: {
                            cell: (props) => <LinkCell3 linkTitle={props.all?.type}/>,
                        },
                    },
                    {
                        type: "wrapperCell",
                        typeData: {
                            cell: (props) => (
                                <LinkCell3 linkTitle={formatDate(props?.all?.created_at)}/>
                            ),
                        },
                    },
                    {
                        type: "wrapperCell",
                        typeData: {
                            cell: (props) => (
                                <StatusCell
                                    color={statusColorSwitcher(props?.all?.status)}
                                    text={props?.all?.status}
                                />
                            ),
                        },
                    },
                ]}
                tableStorage={data}
                tableTitle={""}
                sortHandler={() => {
                }}
                filterChangeURL={(e) => filterHandler(e)}
                showCountChanger={limitHandler}
                setActualPage={offsetHandler}
                breadCrumbsItems={[
                    {title: "Главная"},
                    {title: "Обращения", actual: true},
                ]}
                filterFieldsConf={{
                    period: true,
                    date: true,
                }}
                pagination={pagination}
                filterBarButtons={{downloadTemplate: {show: false}}}
                addOrg={{}}
                exportTemplateButtons={{export: false, registry: false}}
            />
        </>
    );
}

const StyledImage = styled.div`
  background-image: url(${(p: any) => p?.imageLink});
  max-width: 100%;
  max-height: 100%;
  width: 60%;
  height: 60%;
  background-repeat: round;
`;

export default Notifications;
